import { useEffect } from "react";
import { useRouter } from "../useRouter";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import { useGetMyServiceList } from "../api/product/useGetMyServiceList";

// 비 OCI 제품에서 이미 생성된 사이트가 있으면
// /site/promotion 직접 접근을 막고 /console 로 이동시키는 가드 훅
export function useGuardPromotionAccess() {
  const route = useRouter();
  const { isOciProduct } = useProductFlags();
  const { isMyServiceLoading, serviceList } = useGetMyServiceList({});

  // 로딩이 끝나고 생성된 사이트가 있는 비 OCI 제품만 차단 대상
  const isBlocked =
    !isOciProduct && !isMyServiceLoading && serviceList.length > 0;

  useEffect(() => {
    if (isBlocked) {
      route.goConsole();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBlocked]);

  return { isBlocked };
}
